import React, { useState, useEffect } from "react";
import "../css/StaticTable.css";
const API_URL = process.env.REACT_APP_URL;

const formatNumber = (value) => {
  if (value === null || value === undefined || value === '' || Number.isNaN(value)) return '-';
  const number = Number(value);
  if (Number.isNaN(number)) return value;
  return new Intl.NumberFormat('en-IN').format(number);
};

const StaticTable = ({updatedTime}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getYesterdayAndToday = () => {
    const today = new Date();
    const yesterday = new Date(today);
    const beforeYesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    beforeYesterday.setDate(beforeYesterday.getDate() - 2);

    const formatDate = (date) => {
      const options = { year: "numeric", month: "short", day: "2-digit" };
      return date.toLocaleDateString("en-US", options).toUpperCase();
    };

    return {
      yesterday: formatDate(yesterday),
      today: formatDate(today),
      beforeYesterday: formatDate(beforeYesterday),
    };
  };

  const dates = getYesterdayAndToday();

  const normalizeData = (rawData) => {
    console.log("☠️☠️☠️ ~ normalizeData ~ rawData:", rawData)
    if (Array.isArray(rawData)) {
      return rawData;
    }
    return Object.entries(rawData).map(([key, value], index) => {
      if (value && typeof value === "object") {
        return {
          id: value.id ?? key,
          sr_no: index + 1,
          head: value.head ?? key,
          count_till_yesterday: value.yesterday,
          count_till_today: value.today,
          difference: value.difference ?? 0,
        };
      }

      return {
        id: key,
        sr_no: index + 1,
        head: key,
        count_till_yesterday: "-",
        count_till_today: "-",
        difference: "-",
      };
    });
  };

  const loadData = () => {
    setLoading(true);
    setError(null);
    fetch(`${API_URL}/parse-report`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((json) => {
        updatedTime(json.file_last_modified)
        setData(normalizeData(json.data));
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  useEffect(() => { loadData(); }, []);

  const renderText = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return value;
  };

  return (
    <div className="dashboard-container">
      <div className="table-section-title">
        <span className="section-number">A.</span>
        <h2>MAJOR KPIS</h2>
      </div>

      {loading && <p className="table-status">Loading...</p>}
      {error && <p className="table-status">Failed to load data: {error}</p>}

      {!loading && !error && (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th><span className="column-label">Sr No</span></th>
                <th><span className="column-label">Report Parameters</span></th>
                <th><span className="column-label">Cumulative Count till {dates.beforeYesterday}</span></th>
                <th><span className="column-label">Cumulative Count till {dates.yesterday}</span></th>
                <th><span className="column-label">Difference ({dates.yesterday} - {dates.beforeYesterday})</span></th>
              </tr>
            </thead>

            <tbody>
              {data.map((row) => (
                <tr key={row.id ?? row.sr_no}>
                  <td style={{'min-width':'70px'}}>{row.sr_no ?? ""}</td>
                  <td>{row.head ?? ""}</td>
                  <td>{formatNumber(row.count_till_yesterday)}</td>
                  <td>{formatNumber(row.count_till_today)}</td>
                  <td
                    className={
                      typeof row.difference === "number" && row.difference > 0
                        ? "positive"
                        : typeof row.difference === "number" && row.difference < 0
                        ? "negative"
                        : "neutral"
                    }
                  >
                    {typeof row.difference === "number" && row.difference > 0 ? "+" : ""}
                    {formatNumber(row.difference) ?? ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default StaticTable;
